import React, {Component} from 'react';
import axios from 'axios';
import auth0Client from '../Auth';
import {SERVER_URL, ATTACHMENT_OBJECT_TYPE_LOSTITEM}  from '../Constants';
import {ToastContainer, ToastStore} from 'react-toasts';



class Attachments extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        attachments:[],
        fileName:'',
     
        base64Data : undefined
      };
      this.load();
    }
    formatDate=(dateStr)=>{
        try {
            if (dateStr){
                var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                return new Date(dateStr).toLocaleDateString([],options);
            }else{
                return  '';
            }
        }catch(e){
            return  '';

        }
        
        
    }
    onFileChange=(e) =>{
        let files= e.target.files;
        if (files.length ===1){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload=(e)=>{
              var data = e.target.result;
              //console.log(data);
              const fileData = {
                  ownerObjectId : this.props.ownerObjectId,
                  objectType: this.props.objectType,
                  base64:data.split(';base64,')[1],
                  fileName: files[0].name
              }
            
              // upload the new file to the venue account
              axios.put(`${SERVER_URL}/Attachments/upload`,
                fileData,
               { headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`, 'venueId' : auth0Client.getActiveVenuedId() }
                }).then((res)=>{
                    ToastStore.success('Attachment Uploaded');
                    this.load();
               
               
              }).catch((e)=>{
                ToastStore.success('Attachment Upload Failed ' + e.message);
              });  
            }
        }
      }

      componentDidUpdate(prevProps, prevState) {
        if (prevProps.something !== this.props.something) {
            console.log('something prop has changed.')
     }
        //this.load();
    }

    delete=(item)=>{
        if (item){
            if (window.confirm("Are you sure you want to delete the attachment?")){
                axios.post(`${SERVER_URL}/Attachments/delete`,
                            {id:item._id, fileName:item.fileName},
                        
                        {
                        headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`, 'venueId' : auth0Client.getActiveVenuedId() }
                        }
                        ).then((res)=>{
                           
                            ToastStore.success('Attachment Deleted');
                            this.load();
                        }).catch((e)=>{
                            console.log(e);
                            ToastStore.error(e.message);
                    });  
            }
        }
    }

    load=async()=>{
        try {
            let query = {
                ownerObjectId: this.props.ownerObjectId,
                objectType:ATTACHMENT_OBJECT_TYPE_LOSTITEM
            }
            //console.log(query);
            axios.post(`${SERVER_URL}/Attachments/query`,
                    query,
                
                {
                headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`, 'venueId' : auth0Client.getActiveVenuedId() }
                }
                ).then((res)=>{
                    const attachments  = res.data;
                   
                    if (attachments){
                    this.setState({
                        attachments: attachments,
                    
                    });
                }
              }).catch((e)=>{
          
              });  
        } catch (error) {
            
        }
    }
    openWindow=(url)=>{
        window.open(url, '_blank', 'menubar=1,toolbar=1, location=0');
    }
    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
    }
    
    renderList=()=>{
        
        if(this.state.attachments){
          
            return(
            
           
                this.state.attachments.map((item)=>(
                    <div className="row">
                        <div className='col'>
                            <p className="text-primary" ><b>{item.fileName}</b></p>
                        </div>
                        <div className='col'>
                            <p className="text-primary" ><b>{this.formatDate(item._created_at)}</b></p>
                        </div>
                        <div className='col-2' align='right'>
                            <button className="btn btn-info btn-sm" onClick={()=>{this.openWindow(item.url)}}>Open</button>
                        </div>
                        <div className='col-2' align='right'>
                            <button className="btn btn-danger btn-sm" onClick={()=>{this.delete(item)}}>Delete</button>
                        </div>
                    </div>
            ))

            )
        }

    }
    render(){
                return (
                    <div>
                      <div className="row">
                            <div className='col'> 
                                <div align='right'>
                                    Attach New File...
                                    <input type="file" name='file' className="btn btn-outline-success btn-sm"  onChange={(e)=>this.onFileChange(e)} />
                                        
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className='col'> 
                                {this.renderList()}
                            </div>
                        </div>
                        {this.renderToast()}
                    </div>
                );
        };
    
}
export default Attachments